class CommonValues {
  static Logout = (navigate: any) => {
    localStorage.removeItem("igtoken");
    localStorage.removeItem("userName");
    localStorage.removeItem("NowcertsAgentId");
    localStorage.removeItem("AvatarName");

    navigate("/");
  };
  static GetToken = () => {
    return localStorage.getItem("igtoken");
  };
}
export default CommonValues;
